<main class="dialog-edit-advisor">
  <div>
    <h1 mat-dialog-title class="dialog-edit-advisor__title">
      {{ modalInformation.advisor ? ("EditAdvisor" | translate):("AddAdvisor" |
      translate)}}
    </h1>

    <div mat-dialog-content class="dialog-edit-advisor_content">
      <div class="dialog-edit-advisor__wrapper">
        <div>
          <mat-form-field>
            <mat-label class="dialog-edit-advisor__label"
              >{{"AdvisorName" | translate}}</mat-label
            >
            <input 
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
              matInput
              type="text"
              [(ngModel)]="advisorName"
              maxlength="20"
            />
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label class="dialog-edit-advisor__label"
              >{{"Phone" | translate}}</mat-label
            >
            <input
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
              matInput
              type="text"
              [(ngModel)]="phoneNumber"
              maxlength="20"
              (input)="onInput()"
            />
          </mat-form-field>
          <mat-error *ngIf="showError">
            {{"ObligatoryNumbers" | translate}}
          </mat-error>
        </div>

        <div *ngIf="helperService.user.role.roleId===4">
          <mat-form-field>
            <mat-label class="dialog-edit-advisor__label"
              >{{"Workshop" | translate}}</mat-label
            >
            <mat-select [(ngModel)]="workshopSelected">
              <mat-option
                *ngFor="let workshop of  modalInformation.workshop ; let i = index"
                [value]=" workshop.workshopId"
                (click)="SelectWorkshop(i)"
                >{{workshop.workshopName}}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <div >
          <mat-form-field >
            <mat-label>{{'SelectBrands' | translate}}</mat-label>
            <mat-select  class="brand-label" [(ngModel)]="brandsSelected" multiple>
                <mat-option *ngFor="let dataItem of brands"  (click)="setCreationBrands()" 
                [value]="dataItem.brandId">
                    {{dataItem.brandName}}
                </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <p class="dialog-edit-advisor__header">
            {{"ActivateDeactivateAdvisorService" | translate}}
          </p>
        </div>
      </div>
      <div class="dialog-edit-advisor__wrapper-bottom">
       
        <div *ngFor="let service of typesOfService; let i = index">
          <mat-slide-toggle
            *ngIf="service.serviceName !== ''"
            [(ngModel)]="service.isActive"
          >
            {{service.serviceName | translate}}
          </mat-slide-toggle>
        </div>
      </div>

      <div *ngIf="typesOfService.length === 0">
        <p class="dialog-edit-advisor__message">
          {{"SelectWorkshop" | translate}}
        </p>
      </div>
    </div>

    <mat-dialog-actions align="center">
      <button class="dialog__button" [mat-dialog-close]>
        {{"Cancel" | translate}}
      </button>
      <button
        class="dialog__button dialog__button--fill"
        [disabled]="validationForm()"
        (click)="onSave()"
      >
        {{"Accept" | translate}}
      </button>
    </mat-dialog-actions>
  </div>
</main>
